import { Box } from '@mui/material';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import './home.css'
import { useTranslation } from 'react-i18next';

const EConsumerConsentError = ({setErrorState}) => {
    const { t } = useTranslation();

    return (
        <Box className="eConsent-error">
            <div className='error-icon-box'>
                <ErrorOutlinedIcon className='error-icon'/>
            </div>
            <h4>{t('Something went wrong!')}</h4>
            <p>
                {t('Your electronic consent has not yet been submitted. We are currently working on resolving the issue. Please Retry in a short while.')}
            </p>
            <button type="button" onClick={() => {
                setErrorState((prevConsents) => ({
                    ...prevConsents,
                    showModels: false,
                    error: false,
                    loanLockStatus: false
                }))
            }}
                className="selected"
            >
                {t('Okay')}
            </button>
        </Box>
    );
};

export default EConsumerConsentError;
